import { translate } from "../../util/translate"

export const realEstateUsersHeaders = [
  {
    text: translate['realEstateUsers.table.name'],
    value: 'name',
    width: 300,
  },
  {
    text: translate['realEstateUsers.table.username'],
    value: 'username',
    width: 200,
  },
  {
    text: translate['realEstateUsers.table.type'],
    value: 'type',
    width: 200,
  },
  {
    text: translate['realEstateUsers.table.status'],
    value: 'enabled',
    width: 50,
    align: 'center',
  },
  {
    value: 'actions',
    align: 'end',
    width: 100,
  },
]
